import { extend } from 'vee-validate';
import passwordStrength from './password-strength.validator';

extend('password-strength', passwordStrength);
